



















import { Vue, Component, Prop } from 'vue-property-decorator';
import EnumObject from '@/domain/enum-object.entity';

@Component
export default class FeeDiscountTypeSelectComponent extends Vue {
  @Prop({ type: String, required: true }) value!: string;

  @Prop({ type: String, required: true }) label!: string;

  @Prop({ type: Boolean, required: true }) disabled!: boolean;

  @Prop({ type: Array, default: true }) types!: Array<EnumObject>;

  emitInput(value: string): void {
    this.$emit('input', value);
  }
}
